import React, { useEffect, useState, useCallback } from 'react';

function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

export default function PwaBanners({ updateRegistration, onDismissUpdate }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosHint, setShowIosHint] = useState(false);
  const [installDismissed, setInstallDismissed] = useState(
    () => localStorage.getItem('pwaInstallDismissed') === '1'
  );

  useEffect(() => {
    const onBip = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', onBip);
    if (isIos() && !isStandalone() && !installDismissed) {
      setShowIosHint(true);
    }
    return () => window.removeEventListener('beforeinstallprompt', onBip);
  }, [installDismissed]);

  const dismissInstall = useCallback(() => {
    localStorage.setItem('pwaInstallDismissed', '1');
    setInstallDismissed(true);
    setShowIosHint(false);
    setDeferredPrompt(null);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  const handleUpdate = () => {
    const reg = updateRegistration;
    if (reg?.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
    onDismissUpdate?.();
  };

  if (updateRegistration) {
    return (
      <div className="fixed inset-x-0 top-0 z-[70] safe-pb bg-indigo-700 px-3 py-2 text-center text-sm text-white shadow">
        Nuova versione disponibile.{' '}
        <button type="button" onClick={handleUpdate} className="ml-2 underline font-semibold">
          Ricarica
        </button>
      </div>
    );
  }

  if (!installDismissed && deferredPrompt) {
    return (
      <div className="fixed inset-x-0 bottom-[calc(4.5rem+env(safe-area-inset-bottom,0px))] z-[60] mx-2 mb-2 rounded-xl border border-indigo-300 bg-white px-3 py-2 text-sm shadow-lg dark:border-indigo-700 dark:bg-gray-800 sm:bottom-4">
        <div className="flex items-center justify-between gap-2">
          <span className="text-gray-800 dark:text-gray-100">Installa Country Dance Hub come app</span>
          <div className="flex gap-2 shrink-0">
            <button type="button" onClick={dismissInstall} className="px-2 py-1 text-gray-500">
              Dopo
            </button>
            <button
              type="button"
              onClick={handleInstall}
              className="rounded-lg bg-indigo-600 px-3 py-1.5 text-white"
            >
              Installa
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (showIosHint && !installDismissed) {
    return (
      <div className="fixed inset-x-0 bottom-[calc(4.5rem+env(safe-area-inset-bottom,0px))] z-[60] mx-2 mb-2 rounded-xl border border-indigo-300 bg-white px-3 py-2 text-sm shadow-lg dark:border-indigo-700 dark:bg-gray-800 sm:bottom-4">
        <div className="flex items-start justify-between gap-2">
          <p className="text-gray-800 dark:text-gray-100">
            Su iPhone: tocca <strong>Condividi</strong> e poi <strong>Aggiungi a Home</strong>.
          </p>
          <button type="button" onClick={dismissInstall} className="shrink-0 px-2 py-1 text-gray-500">
            OK
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export function NetworkBanner({ online, stale }) {
  if (online && !stale) return null;
  return (
    <div
      className={`sticky top-0 z-40 px-3 py-1.5 text-center text-xs font-semibold ${
        online
          ? 'bg-amber-100 text-amber-900 dark:bg-amber-900/50 dark:text-amber-100'
          : 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-100'
      }`}
    >
      {online ? 'Dati non aggiornati (ultima sync offline)' : 'Sei offline — consultazione dalle copie locali'}
    </div>
  );
}
